<template>
  <b-modal
      id="public-holidays-modal"
      ref="public-holidays-modal"
      size="md-size"
      modal-class="public-holidays-modal"
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      hide-header
      @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('public_holidays') }}
      </h2>
      <div class="field-wrap">
        <p class="label">
          <i class="atto atto-rdir-arrow-b"></i>
          {{ label.get("country") }}
        </p>
        <select-dropdown-component
            v-if="countries && countries.length"
            :options="countries"
            placeholder="Select..."
            :value="country_id"
            @onOptionSelected="onCountrySelected"
        />
      </div>
    </div>
    <div class="content-wrapper">
      <div class="table-heading">
        <span class="heading-label holiday">{{ label.get('holiday') }}</span>
        <span class="heading-label date">{{ label.get('date') }}</span>
      </div>
      <div
          class="add-new"
          @click="addNewCustomHoliday"
      >
        <i class="atto atto-add-more" />
        <h4>{{ label.get('add_custom_holiday') }}</h4>
      </div>
      <div class="content-wrapper hasScroll">
        <perfect-scrollbar>
          <ul class="holidays">
            <li v-for="(item, idx) in holidaysList"
                v-show="!item.deleted"
                :key="idx">
              <span class="holiday">
                {{item.holiday_name}}
                <i class="custom-holiday-icon" v-if="item.type !== undefined && item.type === 'custom'">{{label.get('custom')}}</i>
              </span>
              <span class="date">{{item.holiday_date}}</span>
              <button
                  v-if="!item.deleting"
                  class="delete-holiday"
                  @click="deleteHoliday(item)"
              >
                <i class="atto atto-delete" />
              </button>
              <transition
                  v-if="item.confirm_delete && !item.deleting"
                  name="fade"
              >
                <div class="confirm-delete">
                  <span class="confirm-msg">{{label.get('are_you_sure')}}</span>
                  <button
                      class="confirm-delete-btn"
                      @click="confirmDeleteHoliday(idx, item)"
                  >
                    {{ label.get('delete') }}
                  </button>
                  <button
                      class="cancel-delete"
                      @click="cancelConfirmDelete(item)"
                  >
                    <i class="atto atto-close-btn" />
                  </button>
                </div>
              </transition>
            </li>
            <li v-for="(item, idx) in customHolidays"
                class="pending-holidays"
                :key="'customHoliday' + idx"
            >
              <div class="pending-input">
                <input
                    v-model="item.holiday_name"
                    ref="name"
                    type="text"
                    :placeholder="label.get('enter_custom_holiday_name')"
                    :class="{ 'has-error': item.error}"
                />
              </div>
              <div class="date">
                <simple-datepicker-component
                    :initial-date="item.holiday_date"
                    v-model="item.holiday_date"
                    :class="{ 'has-error': item.error}"
                    @onDateSelected="onDateSelected"
                />

              </div>
              <button
                  class="delete-holiday"
                  @click="deleteNewCustomHoliday(idx)"
              >
                <i class="atto atto-delete" />
              </button>
            </li>
          </ul>
        </perfect-scrollbar>
      </div>
    </div>
    <div class="modal-footer">
      <button
          type="reset"
          class="atto-btn cancel"
          @click="close"
      >
        {{ label.get('cancel') }}
      </button>
      <button
          type="submit"
          class="atto-btn submit"
          :disabled="disabledSubmitButton"
          @click="savePublicHolidays"
      >
        {{ label.get('save_changes') }}
      </button>
    </div>
  </b-modal>
</template>

<script>
import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";
import CompactDatepickerComponent from "../../../timesheets/components/CompactDatepickerComponent";
import WorkweekOvertimeService from "../services/WorkweekOvertimeService";
import UtilsService from "../../../../shared/services/UtilsService";
import SimpleDatepickerComponent from "../../../../shared/components/SimpleDatepickerComponent";
import MemberService from "../../manage-team/services/MemberService";
export default {
  name: "PublicHolidaysComponent",
  components: {SimpleDatepickerComponent, CompactDatepickerComponent, SelectDropdownComponent},
  data() {
    return{
      members : this.$store.state.members,


      country_id: this.$store.state.userSettings.public_holiday_country_id,
      countries: this.$store.state.countries ? this.$store.state.countries.map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      }) : [],
      holidays: [],
      holidaysList: Object.assign([], this.holidays),
      customHolidays: this.$store.state.companyHolidays,
      disabledSubmitButton: false,
      user: this.$store.state.userSettings
    }

  },
  created() {
    let selectedMember = this.members.filter(item => item.uid === this.$route.params.uid)[0];

    this.country_id = selectedMember.user_settings.public_holiday_country_id;
    this.$store.state.userSettings.public_holiday_country_id = this.country_id;
    this.getHolidays();
    this.customHolidays = []
  },
  mounted() {
    document.body.appendChild(this.$el);
    this.$refs['public-holidays-modal'].show();

    if(!this.countries.length){
      this.getCountries()
    }
  },
  methods: {
    getCountries(){
          WorkweekOvertimeService.getCountries().
      then((result) => {
            this.$store.state.countries = result;
            this.countries = this.$store.state.countries ? this.$store.state.countries.map((item) => {
              return {
                value: item.id,
                label: item.name,
              };
            }) : [];
          // this.$store.commit('hideLoading');
          // this.$root.$emit('hideAddManagersToDep', selectedManagers);
        }).catch(() => {
          // this.$store.commit('hideLoading');
          // this.$awn.alert(this.label.get('an_error_occurred_while_adding_members_to_this_department'));
        })
    },
    getHolidays(){

      this.$store.commit("showLoading");
      const countryId = this.$store.state.userSettings.public_holiday_country_id
      const stateHolidays = this.holidaysList;
      WorkweekOvertimeService.getPublicHolidays(countryId).
      then((result) => {
        this.holidaysList = result.map((item) => {
          item.deleted = false;
          item.deleting = false;
          item.confirm_delete = false;
          const holiday = stateHolidays.find((holiday) => {
            return holiday.id === item.id;
          });
          if (holiday)  {
            item.holiday_name = holiday.holiday_name;
            item.holiday_date = holiday.holiday_date;
            item.type = holiday.type;
            item.country_id = holiday.country_id
          }
          return item;
        });
        this.$store.commit('hideLoading');
      }).catch((error) => {
        console.log(error)
        this.$store.commit('hideLoading');
      });
    },
    addNewCustomHoliday() {
      let members = this.$store.state.members;
      let selectedMember = members.filter(item => item.uid === this.$route.params.uid)[0];

      let emptyFields = false;
      this.customHolidays.forEach((item) => {
        if (item.holiday_name.trim() === '' || item.holiday_date.trim() === '') {
          emptyFields = true;
        }
      });
      if (!emptyFields) {
        this.customHolidays.push({
          id: null,
          holiday_name: '',
          holiday_date: '',
          user_id: selectedMember?.id ?? null,
          error: false
        });
      }
      const _this = this;
      setTimeout(function() {
        _this.$nextTick(() => {
          const last = _this.$refs.name.pop();
          last.focus();
        });
      }, 100);

    },
    deleteNewCustomHoliday(idx) {
      this.customHolidays.splice(idx, 1);
    },
    onCountrySelected(item) {

      let members = this.$store.state.members;
      let selectedMember = members.filter(item => item.uid === this.$route.params.uid)[0];


      this.$store.commit("showLoading");
      this.country_id = item.value;
      this.$store.state.userSettings.public_holiday_country_id = this.country_id;
      this.$store.state.members.filter(item => item.uid === this.$route.params.uid)[0].user_settings.public_holiday_country_id = item.value;

      const countryId = this.country_id;
      const stateHolidays = this.holidaysList;
      let data = {user_id:selectedMember.id,public_holiday_country_id: item.value}

      WorkweekOvertimeService.updateSelectedCountry(data).then((result) => {


        this.country_id = data.public_holiday_country_id
      }).catch((error) => {
        console.log(error)
      });

      WorkweekOvertimeService.getPublicHolidays(countryId).
      then((result) => {

        this.holidaysList = result.map((item) => {
          item.deleted = false;
          item.deleting = false;
          item.confirm_delete = false;
          const holiday = stateHolidays.find((holiday) => {
            return holiday.id === item.id;
          });
          if (holiday)  {
            item.holiday_name = holiday.holiday_name;
            item.holiday_date = holiday.holiday_date;
            item.type = holiday.type;
          }
          return item;
        });
        this.$store.commit('hideLoading');
      }).catch((error) => {
        console.log(error)
        this.$store.commit('hideLoading');
      });
    },
    deleteHoliday(item) {
      item.confirm_delete = true;
    },
    cancelConfirmDelete(item) {
      item.confirm_delete = false;
    },
    confirmDeleteHoliday(idx, item) {
      if (item.id === null) {
        this.holidays.splice(idx, 1);
        return;
      }
      this.holidaysList[idx].deleted = true;
    },
    onDateSelected(date){
      if (date === undefined || date === null) {
        return;
      }
      this.customHolidays.forEach((item) => {
        return item.holiday_date = date;
      });
    },
    savePublicHolidays() {

      let members = this.$store.state.members;
      let selectedMember = members.filter(item => item.uid === this.$route.params.uid)[0];
      const customHolidays = this.customHolidays.filter((item) => {
        return item.holiday_name !== '' && item.holiday_date !== ''
      });

      let data = customHolidays.map((item, idx) => {
        item.public_holiday_id = null;
        item.deleted = false;
        item.index = idx;
        item.user_id = selectedMember?.id ?? null;
        return item;
      });
      const deletedItems = this.holidaysList.filter((item) => {
        return item.deleted;
      })
      data = [...data, ...deletedItems];
      // const countryId = this.$store.state.userSettings.public_holiday_country_id;
      const countryId = this.country_id;

      if (data.length > 0 || countryId !== '') {
        this.$store.commit("showLoading");
        WorkweekOvertimeService.addCustomHolidays({
          holidays: data,
          country_id: countryId,
          user_id: selectedMember?.id ?? null,
        }).then((result) => {

          this.customHolidays = {};

          this.getHolidays();
          this.holidaysList.forEach((item) => {
            if (item.deleted) {
              const holiday = this.holidaysList.find((holiday) => {
                return holiday.id === item.id
              });
              if (holiday !== null) {
                const idx = this.holidaysList.indexOf(holiday);
                this.holidaysList.splice(idx, 1);
              }
            }
          });
          this.$store.commit("hideLoading");
          this.$root.$emit('onPublicHolidaysClose');
        }).catch((error) => {
          this.$store.commit("hideLoading");
        })
      }
      else {
        this.$root.$emit('onPublicHolidaysClose');
      }
      this.$store.commit("showLoading");
      this.disabledSubmitButton = true;
    },
    close() {
      this.$root.$emit('onPublicHolidaysClose');
    }
  }
}
</script>

<style lang="scss">
.public-holidays-modal{
  .modal-content .content-wrapper > .ps .ps__rail-y{
    right: 0 !important;
  }
  .modal-content .content-wrapper > .ps {
    padding-right: 0 !important;
  }
  .modal-md-size{
    width: 600px;
    max-width: 600px;
  }
  .modal-head{
    padding: 40px 16px 16px 20px;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;

    .field-wrap{
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-flow: row;

      p.label{
        margin: 0 22px 0 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include fontSize(14px);
        @include lHeight(28px);
        font-family: $roboto-font;
        color: $atto-font-color;

        i{
          @include fontSize(10px);
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .atto-select{
        width: 185px;
      }
    }
  }
  .modal-body {
    .content-wrapper {
      padding: 0!important;

      .table-heading {
        background-color: #fafafa;
        border-top: 1px solid #efefef;
        border-bottom: 1px solid #efefef;
        padding: 12px 20px;
        display: flex;
        flex-direction: row;
        height: 35px;
        align-items: center;
        justify-content: flex-start;

        span {
          font-family: $roboto-font;
          @include fontSize(10px);
          @include lHeight(11px);
          color: #666666;
          margin-right: 8px;
          text-transform: uppercase;
          letter-spacing: 0.5px;

          &.date {
            flex-grow: 1;
          }

          &.holiday {
            width: 280px;
          }

          &.mobile-only {
            display: none;
          }
        }
      }

      .holidays {
        > li {
          display: flex;
          flex-direction: row;
          padding: 15px 16px 15px 20px;
          height: 50px;
          border-bottom: 1px solid #efefef;
          align-items: center;
          position: relative;

          .holiday{
            font-family: $roboto-font;
            @include fontSize(15px);
            @include lHeight(24px);
            font-weight: $roboto-regular;
            display: inline-flex;
            align-items: center;
            width: 280px;
            min-width: 280px;
            margin-right: 12px;
            color: $atto-font-color;

            .custom-holiday-icon{
              width: 40px;
              height: 12px;
              border-radius: 6px;
              background-color: $atto-pink;
              color: $atto-white;
              @include fontSize(9px);
              @include lHeight(20px);
              font-weight: $roboto-bold;
              display: flex;
              align-items: center;
              justify-content: center;
              font-style: normal;
              text-transform: capitalize;
              margin-left: 6px;
            }
          }

          .date {
            width: 240px;
            margin-bottom: 0;
            margin-right: 16px;
            font-family: $roboto-font;
            font-weight: $roboto-regular;
            @include fontSize(14px);
            @include lHeight(16px);
            color: $atto-font-color;
          }
          button.delete-holiday {
            display: none;
          }
          &.pending-holidays {
            .pending-input {
              width: 280px;
              min-width: 280px;
              margin-right: 12px;

              input {
                color: #262626;
                width: 100%;
                height: 40px;
                font-family: "Roboto", sans-serif;
                font-size: 0.875rem;
                line-height: 1.5rem;
                font-weight: 400;
                padding: 8px 12px;
                border: 2px solid #efefef;
                @include base-transition(ease all 0.15s);

                &:focus {
                  border: 2px solid $atto-not-active;
                }

                &.has-error {
                  border-color: #E05656;
                  box-shadow: none;
                }
              }

            }

            .pending-label {
              width: 216px;
              margin-right: 16px;
              color: #999;
              font-family: "Roboto", sans-serif;
              font-size: 0.875rem;
              line-height: 1.5rem;
              font-weight: 400;
            }

            .date {
              margin-right: 24px;
              margin-left: auto;
            }

            button.delete-holiday {
              margin: 0;
              padding: 0;
              width: 24px;
              height: 24px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: auto;

              i {
                font-size: 18px;
                color: $atto-font-color;
                @include base-transition(ease all 0.15s);
              }

              &:hover {
                i {
                  color: #262626;
                }
              }
            }
          }
          &:hover{
            background-color: $atto-white;
            button.delete-holiday {
              margin: 0;
              padding: 0;
              width: 24px;
              height: 24px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-left: auto;

              i {
                font-size: 18px;
                color: $atto-font-color;
                @include base-transition(ease all 0.15s);
              }

              &:hover {
                i {
                  color: #262626;
                }
              }
            }
          }
          .confirm-delete {
            position: absolute;
            right: 0;
            top: 0;
            background-color: #fff;
            width: 250px;
            height: 100%;
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: flex-end;
            padding-left: 0px;
            padding-right: 24px;

            .confirm-msg {

              font-size: 0.875rem;
              line-height: 1.75rem;
              font-family: "Roboto", sans-serif;
              font-weight: 400;
              color: #262626;

            }

            .confirm-delete-btn {

              font-size: 0.875rem;
              line-height: 1.75rem;
              font-family: "Roboto", sans-serif;
              font-weight: 500;
              color: #262626;
              margin-left: 12px;
              padding: 0;
              cursor: pointer;

            }

            .cancel-delete {
              width: 24px;
              height: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              margin-left: 24px;
              padding: 0;
              cursor: pointer;

              i {
                font-size: 14px;
                color: #c7c7c7;
                @include base-transition(ease color 0.15s);
              }

              &:hover {
                i {
                  color: $atto-not-active;
                }
              }
            }
          }
        }
      }

      .add-new {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 16px;
        height: 50px;
        border-bottom: 1px solid #efefef;

        i {
          width: 24px;
          height: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
          @include fontSize(10px);
          color: $atto-teal;
          margin-right: 8px;
        }

        h4 {
          color: $atto-teal;
          font-family: $roboto-font;
          @include fontSize(15px);
          @include lHeight(24px);
          font-weight: $roboto-medium;
          @include base-transition(ease all 0.15s);
          text-transform: capitalize;
        }

        &:hover {
          cursor: pointer;

          h4 {
            color: $atto-dark-teal;
          }
        }
      }

      .confirm-delete {
        position: absolute;
        right: 0;
        top: 0;
        background-color: #fff;
        width: 212px;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: row;
        justify-content: flex-end;
        padding-left: 0px;
        padding-right: 24px;

        .confirm-msg {

          font-size: 0.875rem;
          line-height: 1.75rem;
          font-family: "Roboto", sans-serif;
          font-weight: 400;
          color: #262626;

        }

        .confirm-delete-btn {

          font-size: 0.875rem;
          line-height: 1.75rem;
          font-family: "Roboto", sans-serif;
          font-weight: 500;
          color: #262626;
          margin-left: 12px;
          padding: 0;
          cursor: pointer;

        }

        .cancel-delete {
          width: 24px;
          height: 24px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 24px;
          padding: 0;
          cursor: pointer;

          i {
            font-size: 14px;
            color: #c7c7c7;
            @include base-transition(ease color 0.15s);
          }

          &:hover {
            i {
              color: $atto-not-active;
            }
          }
        }
      }
    }
  }
  .modal-content{
    .modal-footer{
      padding: 32px 16px;
      max-width: 416px;
      display: flex;
      flex-flow: row;
      justify-content: flex-end;
      margin-left: auto;
    }
  }
}

</style>